import { render, staticRenderFns } from "./priceformat.vue?vue&type=template&id=6f613e3f&"
import script from "./priceformat.vue?vue&type=script&lang=js&"
export * from "./priceformat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f613e3f')) {
      api.createRecord('6f613e3f', component.options)
    } else {
      api.reload('6f613e3f', component.options)
    }
    module.hot.accept("./priceformat.vue?vue&type=template&id=6f613e3f&", function () {
      api.rerender('6f613e3f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-28UMQwaCM5jwA/JS/priceformat.vue"
export default component.exports